<template>
  <div>
    <el-row>
      <el-col class="date2">
        <el-date-picker
          v-model="value1"
          @change="handeldate"
          value-format="yyyy-MM-dd"
          type="date"
          :placeholder="$t(`placeholder.data`)"
         
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div
          v-loading="BalanceLoading"
          id="holderBalance"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import indexJs from "./index";
export default {
  mixins: [indexJs],
};
</script>

<style lang="scss" scoped>
.date2 {
  // background: gold;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
  // padding: 10px 10px;
   padding: 10px 100px !important;
  display: flex;
  justify-content: right;
}
</style>
<style >
.date2 .el-input__inner {
  margin: 0 !important;

}
</style>